<template>
	<painel-shell :contentNoPaddingTop="true">
		<template v-slot:header-left>
			<navigation-header :title="$t('Dashboard')" :subtitle="$t('We care about your well-being.')"></navigation-header>
		</template>

		<pins>
			<template v-slot:header>
				<header-simple :title="$t('Our Pins')" :subtitle="'All our important pins.'"></header-simple>
			</template>
		</pins>

		<permits>
			<template v-slot:header>
				<header-simple :title="$t('Our Permissions')" :subtitle="$t('All permissions you have in idicare.')"></header-simple>
			</template>
		</permits>

		<!-- <spinner v-if="user.loading || accounts.loading || alerts.loading || patients.loading"/>
		<div v-else>
			<alerts-widget
				:user_uid="user_uid"
				:alerts="alerts.data"/>
			<watches-widget
				v-check-user:patients="selectedAccount"
				:user_uid="user_uid"
				:watches="patients.data"/>
			<div>
				<h1>Account number</h1>
				<div>125885</div>
			</div>
			<div>
				<h1>Your balance</h1>
				<div>€125.20</div>
				<h2>Connected credit card</h2>
				<div>XXXX-XXXX-XXXX-1098</div>
			</div>
			<div>
				<h1>Current Plan</h1>
				<a href="#">Change plan</a>
				<div>Plan Base</div>
				<div>Staff: using 1 of 5</div>
				<div>Devices: using 2 of 10</div>
				<div>Renew in 12 Jan 2020</div>
			</div>
		</div> -->
	</painel-shell>
</template>

<script>
import { mapGetters } from 'vuex'
import NavigationHeader from '@/components/navigation/NavigationHeader'
import PainelShell from '@/modules/shell/PainelShell'
import HeaderSimple from '@/modules/ui/HeaderSimple'
import Permits from '@/modules/permits/Permits'
import Pins from '@/modules/pins/Pins'

export default {
	components: {
		HeaderSimple,
		Pins,
		Permits,
		PainelShell,
		NavigationHeader
	},
	props: [
		'user_uid'
	],
	computed: {
		...mapGetters({
			currentUser: 'CURRENT_USER'
		})
	},
	beforeCreate () {
		this.$title('Dashboard')
	}
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard.vue